import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/Reveal";
import { LEGAL_PAGES, LEGAL_NAV, COMPANY } from "@/content/legal";

// One layout for every policy page. The text lives in content/legal.js so a
// wording change never means touching markup.
export default function LegalPage({ slug }) {
  const page = LEGAL_PAGES[slug];

  return (
    <div data-testid={`legal-${slug}`}>
      <section className="relative pt-32 md:pt-40 pb-12 overflow-hidden">
        <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
          backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }} />
        <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal><p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#5B8CFF] mb-5">Legal</p></Reveal>
          <h1 className="font-heading font-medium tracking-tight leading-[0.98] text-4xl md:text-6xl text-white max-w-4xl">
            {page.title}
          </h1>
          <p className="mt-6 font-mono-t text-xs uppercase tracking-widest text-neutral-500">
            Last updated {page.updated}
          </p>
          {page.intro && (
            <p className="mt-6 text-lg text-neutral-400 max-w-3xl leading-relaxed">{page.intro}</p>
          )}
        </div>
      </section>

      <section className="pb-24 border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid lg:grid-cols-[240px_1fr] gap-12 pt-12">
          <nav className="lg:sticky lg:top-28 self-start" aria-label="Legal pages">
            <ul className="flex lg:flex-col flex-wrap gap-x-5 gap-y-2.5">
              {LEGAL_NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    className={`text-sm transition-colors ${n.slug === slug ? "text-white font-semibold" : "text-neutral-500 hover:text-white"}`}
                    aria-current={n.slug === slug ? "page" : undefined}
                  >
                    {n.t}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <article className="max-w-3xl">
            {page.sections.map((s, i) => (
              <section key={s.h} className={i ? "mt-12" : ""}>
                <h2 className="font-heading font-medium tracking-tight text-2xl text-white">{s.h}</h2>
                <div className="mt-4 space-y-4 text-neutral-400 leading-relaxed">
                  {s.p && s.p.map((para, j) => <p key={j}>{para}</p>)}
                  {s.list && (
                    <ul className="list-disc pl-5 space-y-2">
                      {s.list.map((li, j) => <li key={j}>{li}</li>)}
                    </ul>
                  )}
                  {s.after && s.after.map((para, j) => <p key={`a${j}`}>{para}</p>)}
                </div>
              </section>
            ))}

            <div className="mt-16 border-t border-white/10 pt-8 text-sm text-neutral-500 leading-relaxed">
              <p>
                OwnPBX is operated by {COMPANY.legalName}. Questions about this page:{" "}
                <a href={`mailto:${COMPANY.email}`} className="text-white underline underline-offset-4">{COMPANY.email}</a>
              </p>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
}
